const SERVER = process.env.REACT_APP_SERVER

export default SERVER;